var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg404 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255,
    height: 111,
    fill: "none",
    viewBox: "0 0 255 111",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M49.95 98.9a7.75 7.75 0 0 0 15.5 0V82.35h7.25a7 7 0 1 0 0-14h-7.25V10.98c0-5.512-4.468-9.98-9.98-9.98a9.98 9.98 0 0 0-8.016 4.035L1.968 66.366A10.02 10.02 0 0 0 0 72.33c0 5.523 4.477 10.02 10 10.02h39.95zm0-30.55H18.79l31.16-42.58zM224.95 101.9a7.75 7.75 0 0 0 15.5 0V85.35h7.25a7 7 0 1 0 0-14h-7.25V13.98a9.98 9.98 0 0 0-17.996-5.945l-45.486 61.331A10.02 10.02 0 0 0 175 75.33c0 5.523 4.477 10.02 10 10.02h39.95zm0-30.55h-31.16l31.16-42.58z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 12,
    d: "m133.433 6 .324.004c4.66.118 8.688 2.774 10.758 6.636 7.57.74 13.485 7.123 13.485 14.887v62.51C158 98.3 151.3 105 143.036 105h-30.072C104.7 105 98 98.3 98 90.036V27.527c0-7.764 5.915-14.146 13.484-14.887A12.56 12.56 0 0 1 122.567 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B71717",
    d: "M107.382 87.262c0-.849.688-1.537 1.537-1.537h38.731c.849 0 1.537.688 1.537 1.537v2.766a6.15 6.15 0 0 1-6.148 6.148H113.53a6.15 6.15 0 0 1-6.148-6.148z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M107.382 30.087c0 .85.688 1.537 1.537 1.537h38.731c.849 0 1.537-.688 1.537-1.537v-2.766a6.15 6.15 0 0 0-6.148-6.148H113.53a6.147 6.147 0 0 0-6.148 6.148zM107.382 74.351c0-.848.688-1.537 1.537-1.537h38.731c.849 0 1.537.689 1.537 1.537v7.378c0 .849-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537zM107.382 61.441c0-.849.688-1.537 1.537-1.537h38.731c.849 0 1.537.688 1.537 1.537v7.377c0 .85-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537zM107.382 48.53c0-.848.688-1.536 1.537-1.536h38.731c.849 0 1.537.688 1.537 1.537v7.377c0 .849-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537zM107.382 35.62c0-.848.688-1.536 1.537-1.536h38.731c.849 0 1.537.688 1.537 1.536v7.378c0 .849-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#404_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#404_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.675 42.805h25.131l-4.181 6.71h-25.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m118.67 51.106-3.704 9.273h14.029l2.729-5.115h-8.361l1.822-4.158z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.633 61.933-2.668 9.384 8.52-9.384z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "404_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M113 42h30v30h-30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "404_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M113 42.563h30v28.874h-30z"
  })))));
};
export default Svg404;